import Component from '../core/Component'
import { scrollToElement } from '../services/Scroll'
import { closest, triggerEvent } from '../utils/dom'

const STATES = {
    OPEN: 'is-open',
    OPENING: 'is-opening',
    CLOSING: 'is-closing',
    FLASHING: 'is-flashing',
}

const ACTIONS = {
    OPEN: 'open',
    CLOSE: 'close',
    TOGGLE: 'toggle'
}

export default class ToggleBlock extends Component {
    constructor(element, options) {
        super(element, options = {
            ...options
        })

        this.caller = {
            action: null,
            promise: null,
            options: {
                shouldScroll: false,
                shouldFlash: false,
            }
        }
    }

    prepare() {
        this.checkHash()

        if (this.initializedWithHash) {
            setTimeout(() => {
                let parents = closest(this.element, '[data-component="ToggleBlock"]')
                parents.forEach(parent => {
                    const toggleBlock = Component.getFromElement(parent)
                    toggleBlock.open({
                        shouldScroll: false,
                        shouldFlash: false
                    })
                })
                this.open()
            }, 0)
        } else if (this.element.classList.contains('is-active')) {
            this.open({
                shouldScroll: false
            })
        }
    }

    open(options) {
        if (this.element.classList.contains(STATES.OPENING)) {
            return this.caller.promise
        }

        const groupName = this.element.dataset.toggleblockGroup
        if (groupName) {
            const toggleBlockElsInSameGroup = [...document.querySelectorAll(`[data-component="ToggleBlock"][data-toggleblock-group="${groupName}"]`)]
            toggleBlockElsInSameGroup
                .filter(toggleBlockEl => toggleBlockEl !== this.element)
                .map(toggleBlockEl => Component.getFromElement(toggleBlockEl))
                .filter(Boolean)
                .forEach(toggleBlock => toggleBlock.close())
        }

        const caller = {
            promise: null,
            options: {
                action: ACTIONS.OPEN,
                scrollMode: 'auto',
                shouldScroll: true,
                shouldFlash: true,
                ...options
            }
        }

        //pokud je uz otevrenej pres ccska nebo odpredtim, tak resolvnout
        if (this.element.classList.contains(STATES.OPEN) || this.element.offsetHeight === this.element.scrollHeight || window.getComputedStyle(this.element).maxHeight === '100%') {
            this.processActionEnd(caller)
            return Promise.resolve()
        }

        this.element.classList.remove(STATES.CLOSING)

        caller.promise = (new Promise((resolve, reject) => {
            getAllOpenersForElement(this.element).forEach(opener => opener.classList.add('is-open'))
            this.element.classList.add(STATES.OPENING)
            this.element.classList.add(STATES.OPEN)
            this.element.parentNode.classList.add(STATES.OPEN)
            this.element.style.willChange = `max-height`
            this.element.style.transition = `.3s all ease`
            this.element.style.maxHeight = `${this.element.scrollHeight}px`

            const handleTransitionEnd = event => {
                if (event.target !== this.element && event.propertyName !== 'max-height') {
                    return
                }
                this.element.removeEventListener('transitionend', handleTransitionEnd)
                this.processActionEnd(caller)
                triggerEvent(this.element, 'toggleblock-change', {
                    action: ACTIONS.OPEN,
                    caller
                })
                resolve()
            }

            this.element.addEventListener('transitionend', handleTransitionEnd)
        })).then(() => {
            this.element.classList.remove(STATES.OPENING)
        })

        this.caller = caller
        return caller.promise
    }

    toggle(openOptions, closeOptions) {
        if (this.element.classList.contains(STATES.OPEN) || this.element.classList.contains(STATES.OPENING)) {
            return this.close(closeOptions)
        } else {
            return this.open(openOptions)
        }
    }

    close(options) {
        if (this.element.classList.contains(STATES.CLOSING)) {
            return this.caller.promise
        }

        const caller = {
            promise: null,
            options: {
                action: ACTIONS.CLOSE,
                scrollMode: 'auto',
                shouldScroll: false,
                shouldFlash: false,
                ...options
            }
        }

        if (!(this.element.classList.contains(STATES.OPEN) || this.element.classList.contains(STATES.OPENING) || this.element.classList.contains(STATES.CLOSING))) {
            this.processActionEnd(caller)
            return Promise.resolve()
        }

        const promise = new Promise((resolve) => {
            const handleTransitionEnd = event => {
                if (event.target !== this.element && event.propertyName !== 'max-height') {
                    return
                }
                this.element.removeEventListener('transitionend', handleTransitionEnd)
                this.processActionEnd(caller)
                triggerEvent(this.element, 'toggleblock-change', {
                    action: ACTIONS.CLOSE,
                    caller
                })
                resolve()
            }

            const height = this.element.offsetHeight

            getAllOpenersForElement(this.element).forEach(opener => opener.classList.remove('is-open'))
            this.element.classList.remove(STATES.OPEN)
            this.element.classList.remove(STATES.OPENING)
            this.element.parentNode.classList.remove(STATES.OPEN)
            this.element.classList.add(STATES.CLOSING)
            this.element.style.willChange = `max-height`
            this.element.style.maxHeight = `${height}px`
            this.element.offsetHeight
            this.element.addEventListener('transitionend', handleTransitionEnd)
            this.element.style.transition = `.3s all ease`
            this.element.style.maxHeight = `0`
        })

        promise.then(() => {
            this.element.classList.remove(STATES.CLOSING)
        })

        return this.caller.promise
    }

    flash() {
        // const handleAnimationEnd = () => {
        //     this.element.classList.remove(STATES.FLASHING)
        //     this.element.removeEventListener('animationend', handleAnimationEnd)
        // }
        // this.element.classList.add(STATES.FLASHING)
        // this.element.addEventListener('animationend', handleAnimationEnd)
    }

    processActionEnd(caller) {
        this.element.style.willChange = ``
        this.element.style.transition = ``
        this.element.style.maxHeight = ``

        if (caller.options.shouldScroll) {
            scrollToElement(this.element.parentElement, { mode: caller.options.scrollMode })
        }

        if (caller.options.shouldFlash) {
            this.flash()
        }

        caller.action = null
    }

    checkHash() {
        const url = window.location.href
        const id = url.substring(url.indexOf("#")).replace('#', '')

        if (id && id === this.element.id) {
            this.initializedWithHash = true
        }
    }
}


function getAllOpenersForElement(element) {
    const href = `${element.id.startsWith('/') ? '' : '#'}${element.id}`
    return [...document.querySelectorAll(`[href="${href}"], [data-href="${href}"]`)]
}